/* PDP "stories" — <hover-stories> web component.
   Row of circular video thumbnails; click opens a full-screen slider (prev/next,
   arrow keys, Esc, autoplay of the active video). Ported from the Pimpant FR theme.
   Data comes from product.metafields.custom.stories (list of `story` metaobjects). */
(function () {
  if (window.customElements && customElements.get('hover-stories')) return;

  class HoverStories extends HTMLElement {
    constructor() { super(); this.currentIndex = 0; this.onKeyDown = this.onKeyDown.bind(this); }
    connectedCallback() { this.init(); }
    init() {
      if (this._initialized) return;
      this.modal = this.querySelector('.hover-stories__modal');
      if (!this.modal) return;
      this.slides = [...this.modal.querySelectorAll('.hover-stories__slide')];
      this.videos = [...this.modal.querySelectorAll('.hover-stories__video')];
      this.prevBtn = this.modal.querySelector('[data-action="prev"]');
      this.nextBtn = this.modal.querySelector('[data-action="next"]');
      this.portalModal();
      if (this.slides.length <= 1) { this.prevBtn && this.prevBtn.setAttribute('hidden', ''); this.nextBtn && this.nextBtn.setAttribute('hidden', ''); }
      this.addEventListener('click', (e) => this.onClick(e));
      this.modal.addEventListener('click', (e) => this.onModalClick(e));
      this.addEventListener('keydown', (e) => this.onCircleKeyDown(e));
      this._initialized = true;
    }
    portalModal() {
      if (this.modal.dataset.portaled === 'true') return;
      this.modal.dataset.portaled = 'true';
      this.modal.dataset.storiesHost = this.dataset.sectionId || '';
      document.body.appendChild(this.modal);
    }
    disconnectedCallback() {
      if (this.modal && this.modal.dataset.portaled === 'true' && this.modal.parentElement === document.body) { this.close(); this.modal.remove(); }
    }
    onClick(e) {
      const c = e.target.closest('.hover-story-circle');
      if (!c || !this.contains(c)) return;
      e.preventDefault();
      this.open(Number(c.dataset.index) || 0);
    }
    onModalClick(e) {
      const t = e.target.closest('[data-action]');
      if (!t || !this.modal || this.modal.hidden) return;
      const a = t.dataset.action;
      if (a === 'close') this.close();
      if (a === 'prev') this.goTo(this.currentIndex - 1);
      if (a === 'next') this.goTo(this.currentIndex + 1);
    }
    onCircleKeyDown(e) {
      const c = e.target.closest('.hover-story-circle');
      if (c && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); this.open(Number(c.dataset.index) || 0); }
    }
    onKeyDown(e) {
      if (!this.modal || this.modal.hidden) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
      if (e.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
    }
    open(i) {
      if (!this.modal || !this.slides.length) return;
      this.modal.hidden = false;
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hover-stories-open');
      document.addEventListener('keydown', this.onKeyDown);
      this.goTo(i, { forceLoad: true });
    }
    close() {
      if (!this.modal) return;
      this.pauseAll();
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hover-stories-open');
      document.removeEventListener('keydown', this.onKeyDown);
    }
    goTo(i, opts = {}) {
      if (!this.slides.length) return;
      const n = this.slides.length;
      const idx = Math.max(0, Math.min(i, n - 1));
      if (idx !== this.currentIndex || opts.forceLoad) {
        this.pauseAt(this.currentIndex);
        this.currentIndex = idx;
        this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.currentIndex));
        this.playAt(this.currentIndex);
        this.updateNavState();
      }
    }
    updateNavState() {
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.disabled = this.currentIndex <= 0;
        this.nextBtn.disabled = this.currentIndex >= this.slides.length - 1;
      }
    }
    playAt(i) {
      const v = this.videos[i];
      if (!v) return;
      // Play with sound. Opening/navigating is a user gesture, so iOS allows it
      // when the clip is ready; if not ready yet it plays on canplay (may need a tap).
      v.currentTime = 0;
      const attempt = () => v.play().catch(() => {});
      if (v.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) attempt();
      else v.addEventListener('canplay', attempt, { once: true });
    }
    pauseAt(i) { const v = this.videos[i]; if (v) v.pause(); }
    pauseAll() { this.videos.forEach((v) => v.pause()); }
  }

  customElements.define('hover-stories', HoverStories);
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('hover-stories').forEach((el) => { el._initialized = false; if (typeof el.init === 'function') el.init(); });
  });
})();
